
































































import { TemplateMail } from '@/enum/TemplateMail';
import { getDefaultAloContact } from '@/models/alo/AloContact';
import { Component, Vue } from 'vue-property-decorator';
import { VuetifyConfirmObject } from '@/plugins/confirm/types';

@Component({
  name:"Contact",
  components: {    
  },
})
export default class Contact extends Vue {

    contact = getDefaultAloContact()
    saving = false

    valid = false
    get nameRules() {
      return [
            (v:string) => !!v || 'Le nom est obligatoire'
            //(v:string) => (v && v.length <= 10) || 'Name must be less than 10 characters',
          ]
    }

    get emailRules(){ 
      return [
            (v:string) => !!v || 'L\'email est obligatoire',
            (v:string) => /.+@.+\..+/.test(v) || 'Le format du mail est invalide',
          ]
    }

    get activityList(){
      return this.$store.myGetters.activityList
    }

    created(){
      this.$store.myActions.ADM_ACTIVITY_ENSURE()
    }  

    validate(){
       if ((this.$refs.form as HTMLFormElement).validate()) {
        this.saving = true
        this.contact.mtpId = TemplateMail.Message
        this.$store.myActions.ADM_CONTACT_SAVE_REQUEST(this.contact).then(() => {
          this.contact = getDefaultAloContact()
            this.$confirm("Votre message à bien été envoyée. Une copie vous a été transmise par mail. Nos équipes vous réponderons dans les 48h.",{title: "Merci pour votre message",buttonTrueText:"Fermer et retour accueil",buttonFalseText:""} as VuetifyConfirmObject).finally(()=>{              
            this.$router.push({name:"Home"})
          })          
        }).finally(()=>{
          this.saving = false
        })    
      } 
    }

}
